import { render, staticRenderFns } from "./ManageReportingDialog.vue?vue&type=template&id=2f65cbc1&scoped=true"
import script from "./ManageReportingDialog.vue?vue&type=script&lang=js"
export * from "./ManageReportingDialog.vue?vue&type=script&lang=js"
import style0 from "./ManageReportingDialog.vue?vue&type=style&index=0&id=2f65cbc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65cbc1",
  null
  
)

export default component.exports